"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = require("axios");

var errors_1 = require("./errors");

var API_RECONNECT_MAX_RETRY_COUNT = 3;
var REQUEST_RETRY_TIMEOUT = 1000;

var APIResource = /*#__PURE__*/function () {
  function APIResource(apiClient) {
    _classCallCheck(this, APIResource);

    this.apiClient = apiClient;
    this.path = '';
  }

  _createClass(APIResource, [{
    key: "handleRetry",
    value: function () {
      var _handleRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error, req, retryCount) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.apiClient.hasAvailableNodes()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", new Promise(function (resolve) {
                  return setTimeout(resolve, REQUEST_RETRY_TIMEOUT);
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(retryCount > API_RECONNECT_MAX_RETRY_COUNT)) {
                            _context.next = 2;
                            break;
                          }

                          throw error;

                        case 2:
                          if (_this.apiClient.randomizeNodes) {
                            _this.apiClient.banActiveNodeAndSelect();
                          }

                          return _context.abrupt("return", _this.request(req, true, retryCount + 1));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))));

              case 2:
                return _context2.abrupt("return", Promise.reject(error));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleRetry(_x, _x2, _x3) {
        return _handleRetry.apply(this, arguments);
      }

      return handleRetry;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(req, retry) {
        var _this2 = this;

        var retryCount,
            request,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                retryCount = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 1;
                request = axios_1.default.request(req).then(function (res) {
                  return res.data;
                }).catch(function (error) {
                  if (error.response) {
                    var status = error.response.status;

                    if (error.response.data) {
                      var _error$response$data = error.response.data,
                          errorString = _error$response$data.error,
                          errors = _error$response$data.errors,
                          message = _error$response$data.message;
                      throw new errors_1.APIError(message || errorString || 'An unknown error has occurred.', status, errors);
                    }

                    throw new errors_1.APIError('An unknown error has occurred.', status);
                  }

                  throw error;
                });

                if (!retry) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", request.catch( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(err) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt("return", _this2.handleRetry(err, req, retryCount));

                          case 1:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x6) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 4:
                return _context4.abrupt("return", request);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function request(_x4, _x5) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "headers",
    get: function get() {
      return this.apiClient.headers;
    }
  }, {
    key: "resourcePath",
    get: function get() {
      return "".concat(this.apiClient.currentNode, "/api").concat(this.path);
    }
  }]);

  return APIResource;
}();

exports.APIResource = APIResource;